import OrderActionsToolbar from "../pageInside/payments/OrderActionsToolbar";
import React, { useState, useEffect, useRef } from "react";
// import Layout from "../Layout/Layout";
import {isAuthenticated, sellerlistOrdersStatus } from "../auth";
import Card from '../pageInside/CardOrders2'
import {useLocation,  Link} from "react-router-dom";
import {laguangeElakay} from "../pageInside/dataElakay";
import imgemptyLakay from '../Layout/imgs/no-orders.png' 
import Modal from 'react-bootstrap/Modal'
import FiltersOrders from "../pageInside/filersOrder";
import ButtonPagination from "../pageInside/ButtonPagination";
import Shipped from "../pages/orderShipped"
import TrackingCapture, { normalizeTracking } from "../pageInside/TrackingCapture";
import { listDeliveryOrders } from "../auth/deliveryApi";

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["buyerOrder"]?.[key] || fallback;

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

// ?oid="6768a690d7ba862d29652bcb"&pid="67664f839fd670bbbf03d019"&opid="6768a690d7ba862d29652bcc"
// ?oid=6768a690d7ba862d29652bcb&pid=67664f839fd670bbbf03d019&opid=6768a690d7ba862d29652bcc

const BuyerOrder = (props) => {
    const {
        infoSource
            } = props
    __setElakayInfoSource(infoSource);

            let filorder = {
                orderStatus: "none",
                orderDate: 'months',
                myd: 1,
                asc: 'desc'
            }
        const query = useQuery();
        const [limit, setLimit] = useState(5);
        const [skip, setSkip] = useState(0);
        const [sizeOrders, setSizeOrders] = useState(0);
        const [filtOrders, setFiltOrders] = useState(filorder);
        const [showFilterOrder, setShowFilterOrder] = useState(false);
    const [orders, setOrders] = useState([]);
    const [ordersError, setOrdersError] = useState("");

    const [showOrderView, setShowOrderView] = useState(false);
    const [getOrderID, setOrderID] = useState({oid:'', pid:'', opid:''});
    const [trackingLookup, setTrackingLookup] = useState("");
    const [trackingLoading, setTrackingLoading] = useState(false);
    const [trackingError, setTrackingError] = useState("");
    const [trackingMessage, setTrackingMessage] = useState("");

    const {token } = isAuthenticated();

    const divCatProduct = useRef(null);
    const scrollToParagraph = (ref) => {
         if (ref && ref.current) {
    ref.current.scrollIntoView({ behavior: 'smooth' });
  }
      };

    useEffect(() => {
        laodOrderWalletSeller(token,  limit, filtOrders)
        query.get("oid") && setShowOrderView(true)
        query.get("oid") && setOrderID({oid: query.get("oid"), pid: query.get("pid"), opid: query.get("opid")})
    }, [token,  limit, filtOrders]);

    const bntOderView =(oid, pid,  opid)=>{
        setShowOrderView(true)
        setOrderID({oid, pid, opid})
    }

    const openOrderByTracking = async (tracking) => {
        const normalized = normalizeTracking(tracking);
        if (!normalized) return;

        setTrackingLoading(true);
        setTrackingError("");
        setTrackingMessage("");

        try {
            const data = await listDeliveryOrders(token, {
                tracking,
                status: "all",
                limit: 100
            });
            const matches = data?.orders || [];
            const exactMatches = matches.filter((item) => (
                [
                    item.delivery?.trackingNumber,
                    item.shipmentInfo?.tracking
                ].some((candidate) => normalizeTracking(candidate) === normalized)
            ));
            const match = exactMatches.length === 1
                ? exactMatches[0]
                : (matches.length === 1 ? matches[0] : null);

            if (!match) {
                setTrackingError(
                    matches.length > 1
                        ? "Plusieurs commandes correspondent. Scannez le tracking complet."
                        : "Aucune commande vendeur trouvee avec ce tracking."
                );
                return;
            }

            const productId = match.product?._id;
            if (!match.orderId || !match.orderProductId || !productId) {
                setTrackingError("La commande trouvee ne contient pas tous ses identifiants.");
                return;
            }

            setTrackingLookup(tracking);
            setOrderID({
                oid: String(match.orderId),
                pid: String(productId),
                opid: String(match.orderProductId)
            });
            setTrackingMessage("Commande trouvee. Chargement des donnees de paiement...");
            setShowOrderView(true);
        } catch (lookupError) {
            setTrackingError(lookupError.message || "Impossible de rechercher cette commande.");
        } finally {
            setTrackingLoading(false);
        }
    }

    const laodOrderWalletSeller = async (token, limit, filtOrders, pageSkip = 0) => {
        setOrdersError("")
        try {
            let data = await sellerlistOrdersStatus(token, pageSkip, parseInt(limit), '', filtOrders);
            const total = data?.totalCount?.[0]?.count || 0;
            // A pending-only page may disappear after capture. Show the last
            // remaining page while retaining the current filters and page size.
            if (data && !data.error && pageSkip > 0 && pageSkip >= total) {
                pageSkip = Math.max(0, (Math.ceil(total / parseInt(limit)) - 1) * parseInt(limit));
                data = await sellerlistOrdersStatus(token, pageSkip, parseInt(limit), '', filtOrders);
            }
            if (!data || data.error) {
                setOrders([])
                setSizeOrders(0)
                setOrdersError(data?.error || __elakayText("loadError", "Unable to load orders."))
            } else {
                setSizeOrders(data.totalCount?.[0]?.count || 0)
                setOrders(data.orders)
                setSkip(pageSkip)
            }
        } catch (error) {
            setOrdersError(error.message || __elakayText("loadError", "Unable to load orders."));
        }
    }
    const refreshOrders = () => laodOrderWalletSeller(token, limit, filtOrders, skip);
    const loadMore = () => {
        let toSkip = skip + parseInt(limit);
         scrollToParagraph(divCatProduct)
        sellerlistOrdersStatus(token, toSkip, limit, '',  filtOrders).then(data => {
            if (!data || data.error) {
                setOrdersError(data?.error || __elakayText("loadError", "Unable to load orders."))
            } else {
               setOrdersError("")
               
               setOrders(data.orders)
                setSizeOrders(data.totalCount[0].count)
                setSkip(toSkip)
                // setLoading(false)
            }
        });
    };

    const loadMore0 = () => {
        let toSkip = skip - parseInt(limit);
        scrollToParagraph(divCatProduct)
        sellerlistOrdersStatus(token, toSkip, limit, '',  filtOrders).then(data => {
            if (!data || data.error) {
                setOrdersError(data?.error || __elakayText("loadError", "Unable to load orders."))
            } else {
               setOrdersError("")
               setOrders(data.orders)
                setSizeOrders(data.totalCount[0].count)
                setSkip(toSkip)
                // setLoading(false)
            }
        });
   
    };


    const showOrdersLength = () => {
        if (orders?.length > 0) {
            return (
                <div className="col col-12" style={{ textAlign: "center", backgroundColor: "Gainsboro" }}>
                <h4 className="text-dark m-2 p-0">
                <div className="btn btn-dark btn-md py-1 rounded-4" onClick={()=>setShowFilterOrder(true)}>
                    {/* Filters */}
                    {infoSource.language(infoSource, "title", "filters")}
                    </div> 
                {infoSource.laguangeElakay('title', infoSource.languageAPI).totalOrder} {(skip - parseInt(limit)) + parseInt(limit) + 1} - {((skip + parseInt(limit)) > sizeOrders) ? sizeOrders : (skip + parseInt(limit))}
                 {/* of  */}
                 {' '}
                 {infoSource.language(infoSource, "label", "of")}
                 {' '}
                 {sizeOrders}  
                </h4>
                </div>
            );
        } else {
            return <div className="col-md-9" style={{ textAlign: "center"}}>
                  <h4 className="text-dark m-2 p-0">
                <div className="btn btn-dark btn-md py-1 rounded-4" onClick={()=>setShowFilterOrder(true)}>
                    {/* Filters */}
                    {infoSource.language(infoSource, "title", "filters")}
                    </div> 
                </h4>
                 
                                <img
                                    className="rounded"
                                    src={imgemptyLakay}
                                    alt={__elakayText("t001", "no orders")}
                                    style={{ 
                                        display: 'block',
                                        margin: '0 auto',
                                        width: "100%"
                                     }}
                                />
            </div>
        
        }
    };

    const productALL = (
        <div ref={divCatProduct} className="row my-3 p-0 justify-content-center" style={{ backgroundColor: "WhiteSmoke", border: "1px solid Gainsboro" }}>
               {ordersError
                 ? <div className="col-md-9 alert alert-danger my-3" role="alert">{ordersError}</div>
                 : showOrdersLength()}
            {
            orders?.map((p, i) => (
        <div key={i} className="container m-2">
            <Card
            key= {i+i}
            laguangeElakay={laguangeElakay}
            infoSource ={infoSource}
            product={p}
            // loadingTrakingOder={loadingTrakingOder}
            bntOderView ={bntOderView}
            bnt ={true}
            // orderURL={`/b/orders/${p.orders_id}/${p.products.productID}/view`}
        />
          </div> 
              ))   
            }
                  { orders?.length > 0 && < ButtonPagination
                infoSource ={infoSource}
                size={orders?.length}
                siseProduct={sizeOrders}
                skip={skip}
                limit={parseInt(limit)}
                loadMore={loadMore}
                loadMore0={loadMore0}
            />}
        </div>
            ) 
       const filterOrdersView = ()=>{
        return <Modal
        size="md"
        show={showFilterOrder}
        onHide={() => setShowFilterOrder(false)}
        // dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        centered
    >
        <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
            <h2>
                {/* BuyerOrder Filters */}
                {infoSource.language(infoSource, "title", "ordFilt")}
                </h2>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <FiltersOrders 
         laguangeElakay={laguangeElakay}
         infoSource ={infoSource}
         limit={parseInt(limit)}
         setLimit= {setLimit}
         setFiltOrders={setFiltOrders}
         setShowFilterOrder={setShowFilterOrder}
         filtOrders={filtOrders}
        />

        </Modal.Body>
    </Modal>

    }

    return (
    <> 
      <OrderActionsToolbar onUpdated={refreshOrders} />
      {/* <TrackingCapture
            value={trackingLookup}
            onChange={setTrackingLookup}
            onSubmit={openOrderByTracking}
            loading={trackingLoading}
            title="Ouvrir une commande par tracking"
            submitLabel="Ouvrir la commande"
            message={trackingMessage}
            error={trackingError}
        /> */}
      {showOrderView && <Shipped 
            onUpdated={refreshOrders}
            setShowOrderView={setShowOrderView}
            showOrderView={showOrderView}
            infoSource ={infoSource}
            getOrderID={getOrderID}
        />}
         {filterOrdersView()}
            {productALL}
            {/* <GraffitiOrderSeller /> */}
            {/* {orderVieux()} */}
             </>
    );
};

export default BuyerOrder;
